import React from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { formatNull, formatDate } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';
import WarningPanel from '../../WarningPanel';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const SingleVerification = ({ closeModal, id }) => {
    const { openTimeModal } = useTimeModal();
    const navigate = useNavigate();
    const location = useLocation();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        user_id: '',
        type: 'Плановая',
        complaint: '',
        applicant: '',
        debtor_id: '',
        debtor_name: '',
        case_id: '',
        case_number: '',
        date: '',
        results: '',
        actions: '',
    });
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) handleLogout();

        axios.get(`/api/get-single-verification?id=${id}`)
        .then((response) => {
            setFormInfo(response.data);
            setWarning(null);
        }).catch((error) => {
            console.error(error);
            setWarning(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }, []);


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        Просмотр&nbsp;сведений о проверке
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    {loading ? <Loading />
                    : warning ? <WarningPanel text={warning} />
                    :
                    <>
                    <div className='labelInputWrapper'>
                        <a className='label'>Тип проверки</a>
                        <div className='labelInputRight'>
                            <a>{formatNull(formInfo.type)}</a>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Жалоба</a>
                        <div className='labelInputRight'>
                            <a>{formatNull(formInfo.complaint)}</a>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Заявитель</a>
                        <div className='labelInputRight'>
                            <a>{formatNull(formInfo.applicant)}</a>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Должник</a>
                        <div className='labelInputRight'>
                            <div className='horizontalContainer'>
                                <a>{formatNull(formInfo.debtor_name)}</a>
                                <a>
                                    <button 
                                        type='button' 
                                        className='button miniButton'
                                        style={{ width: 'fit-content' }}
                                        onClick={() => {navigate(`/case/${formInfo.debtor_id}`, { state: { from: location.pathname + location.search + location.hash }})}}
                                    >
                                        Перейти к карточке должника
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Номер дела</a>
                        <div className='labelInputRight'>
                            <div className='horizontalContainer'>
                                <a>{formInfo.case_name ?? '[Номер дела не присвоен]'}</a>
                                <a>
                                    <button 
                                        type='button' 
                                        className='button miniButton'
                                        style={{ width: 'fit-content' }}
                                        onClick={() => {navigate(`/case/${formInfo.case_id}`, { state: { from: location.pathname + location.search + location.hash }})}}
                                    >
                                        Перейти к карточке дела
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата проведения</a>
                        <div className='labelInputRight'>
                            <a>{formatDate(formInfo.date)}</a>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Результат</a>
                        <div className='labelInputRight'>
                            <a>{formatNull(formInfo.results)}</a>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Принятое решение</a>
                        <div className='labelInputRight'>
                            <a>{formatNull(formInfo.actions)}</a>
                        </div>
                    </div>
                    </>}
                </div>
                <div className={styles.bottom}>

                </div>
            </div>
        </div>
    )
}

export default SingleVerification;